import { ChangeDetectorRef, Component, HostListener, OnInit, TemplateRef } from '@angular/core';
import { WIDGET } from '../../models/app-json';
import { FORM, PAGE,PAGE_CONFIG } from '../../models/page_config_json';
import { AbstractControl, AsyncValidatorFn, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { WebServiceService } from '../../services/web-service.service';
import { APIConfigMapping, HTTPAPIConfig, VlDataService, VlHttpService, isNullOrUndefined, matInputErrorStateMatcher } from 'shared-library';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Observable, Subscription, catchError, debounceTime, distinctUntilChanged, of } from 'rxjs';
import { SIDENAV_CONTENTLIST_OPTIONS } from '../../constants/side-nav.cnst';
import { FROMTYPES, PAGETYPES, pageTypeCnsts } from '../../constants/proj.cnst';
import { ErrorStateMatcher } from '@angular/material/core';
import { WebBuilderService } from '../../services/web-builder.service';

@Component({
  selector: 'lib-web-pages',
  templateUrl: './web-pages.component.html',
  styleUrls: ['./web-pages.component.scss']
})
export class WebPagesComponent implements OnInit {
  sideNavContentOptions = SIDENAV_CONTENTLIST_OPTIONS;
  formTypes = FROMTYPES;
  pageTypes = PAGETYPES;  
  pagesdata!: PAGE[];
  activePageId: string = "";
  isEditablePageName: boolean = false;
  selectedPageID: any;
  newPageName = '';
  pageStatus: boolean = false;
  widgetStatus: boolean = false;
  pagePanelStatus: boolean = false;
  selectedPage: PAGE = { pageId: "", pageName: "", forms: [], applicationId: '', pageType: '' };
  selectedSections!: FORM[];
  sectionStatus:boolean=false;
  sectionState:boolean=false;
  widgetState:boolean = false;
  selectedSection!:any;
  selectedForm:any = {form:'',widgets:[]}
  selectedWidget:any = {widgetId:''}
  formIndex:number = 0;
  applicationId!:any;
  validPageName : boolean = false;
  excludedPageTypes: string[] = [this.pageTypes.loginPage,this.pageTypes.landingPage,this.pageTypes.splashScreen]
  widgetDeleteEnabledPages: string[] = [this.pageTypes.customPage,this.pageTypes.landingPage];
  FormGroup!:FormGroup;
  addPageForm!:FormGroup;
  pageNavAndMenGroup!:FormGroup;
  editPage:boolean=false;
  pageId:any
  pageAlreadyExits:boolean = false;
  queryParamsData:any;
  subscriptions:Subscription[] = [];
  isPagenameEmpty: boolean = false;
  pageDeleteMessage:any ='';
  activeSpinner:boolean=false;
  errorPage:string = "";
  entityData:any[] = [];
  entityForm!:FormGroup;
  editPageEntityData:any;
  entityFormEdit:boolean=false;
  entityFormEditWithValue=false;
  isPageNameExist: boolean = false;
  matInputError: ErrorStateMatcher = new matInputErrorStateMatcher();
  isPageCreated: boolean= false;
  resetMenuNav:boolean = false;
  widgetIndex: number = 0;
  navMenuSelectedStatus!:string;
  constructor(private sharedService:WebServiceService,
    private webBuilderService:WebBuilderService,
    private route: ActivatedRoute, 
    private router: Router,
    private dataService: VlDataService,
    private sharedSrv: WebServiceService,
    public dialog: MatDialog,
    private httpService: VlHttpService, private _formBuilder: FormBuilder, private cdRef: ChangeDetectorRef)
    {}

  @HostListener('document:click', ['$event'])
  documentClick(event: Event): void {
   this.onMouseClick();
  }

  ngOnInit(): void {
    this.viewSetters();
    this.pagesdata = [];
    const currentParams = { ...this.route.snapshot.queryParams }
    this.applicationId = currentParams['id'];
        const allPagesSub$ =  this.sharedService.pages$.subscribe((pages) => {
          this.pagesdata = pages;
          if(this.selectedPage)
          {
            this.pagesdata.forEach((page:any) => {
              if((page.pageId === this.selectedPage.pageId)){
                page.open = true;
                this.pagePanelStatus = true;
              }else{
                page.open = false;
              }
          })
          }
        })  
        this.subscriptions.push(allPagesSub$);
      // }
    // })
    this.formbuilder();
    const setSelectedPsgeSub$ =  this.sharedService.selectedPageObj$.subscribe((page) => {
      this.selectedPage = page;
      this.pageNavAndMenuStatusSetter(page.pageConfig);
      for (const page of this.pagesdata) {
        page.open = page.pageId === this.selectedPage.pageId;
        if (page.open) {
          const form = this.selectedPage.forms[this.formIndex];
          form ? form.open = true : false;
          const widget = form ? form.widgets[this.widgetIndex] : null;
          widget ? widget.open = true : false;
          break;
        }
    }
    })
    this.subscriptions.push(setSelectedPsgeSub$);

    const  expansionPanelStates$ =this.sharedService.expansionPanelStatesObj.subscribe((values: any) => {
      this.widgetIndex=values.widgetIndex;
      this.formIndex=values.sectionIndex;
      this.pagesdata.forEach((page) => {
        if (page.pageId == values.pageID) {
          page.open = true;
          this.sectionFormRenderer(page,values.pageID,values.sectionIndex,this.selectedPage.forms[values.sectionIndex]);
          if (values.widgetIndex) {
            this.selectedPage.forms[values.sectionIndex].widgets[values.widgetIndex].open = true;
            this.selectedWidget = this.selectedPage.forms[values.sectionIndex].widgets[values.widgetIndex];
              this.sectionStatus = false;
          } else {
            this.selectedPage.forms[values.sectionIndex].widgets.forEach((widget: WIDGET) => {
              widget.open = false;
            });
          }
        } else {
          page.open = false;
        }
      });
      this.pageStatus = false;
    });

    this.formValueSubscribers()
    this.subscriptions.push(expansionPanelStates$);
    this.changeSubscribe();
  }

  
  
  viewSetters(){
    const currentParams = { ...this.route.snapshot.queryParams }
    this.applicationId = currentParams["id"];

    this.sharedService.sidenavContentlistSubject$.subscribe((value) => {
      if(!value.isActive){
        this.selectedWidget.open = false;
      }
      if(value.id === this.sideNavContentOptions.nav){
        this.navMenuSelectedStatus = 'nav'
      }
    });
  }

  openSelectedPage(pageId:string){
    for (const page of this.pagesdata) {
      page.open = page.pageId === this.selectedPage.pageId;
      if (page.open) {
        const form = this.selectedPage.forms[this.formIndex];
        form ? form.open = true : false;
        const widget = form ? form.widgets[this.widgetIndex] : null;
        widget ? widget.open = true : false;
        break;
      }
  }
  }

  displayView(isNav:boolean){
    this.webBuilderService.closeDrawer();
    if(isNav && this.pageNavAndMenGroup.get('navBarExists')?.value){
      this.navMenuSelectedStatus = 'nav';
      this.sharedService.setSidenavContentlistOption(this.sideNavContentOptions.nav,true);
      this.webBuilderService.enableMainNav();
    }else if(!isNav && this.pageNavAndMenGroup.get('menuBarExists')?.value){
      this.navMenuSelectedStatus = 'menu';
      this.sharedService.setSidenavContentlistOption(this.sideNavContentOptions.menu,true);
     
    }
  }

  formValueSubscribers(){
    this.pageNavAndMenGroup.valueChanges.subscribe((value) =>{
      value.navBarExists == true ? this.webBuilderService.enableMainNav() : this.webBuilderService.disableMainNav();
    })
  }

  pageNavAndMenuStatusSetter(pageConfig:PAGE_CONFIG){
    this.pageNavAndMenGroup.reset();
    this.pageNavAndMenGroup.patchValue({
      navBarExists:pageConfig?.navConfig ? true:false,
      menuBarExists:pageConfig.menuConfig ? true:false
    })

    pageConfig?.navConfig ? this.webBuilderService.enableMainNav() : this.webBuilderService.disableMainNav();
  }

  formbuilder()
  {
    this.FormGroup = this._formBuilder.group({
      key:[],
      label: [], 
      bgColor:[]
    })
   
   this.addPageForm = this._formBuilder.group({
    name:['', Validators.required],
    description:['']
    })
    this.entityForm = this._formBuilder.group({
      selection:'existing',
      name:['', [Validators.required], [this.entityNameValidator()]],
      dropDownData:['',Validators.required]
    })

    this.pageNavAndMenGroup = this._formBuilder.group({
      navBarExists:[],
      menuBarExists:[]
    }) 
  }

  entityNameValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<{ [key: string]: any } | null> => {
      const enteredName = control.value;
      const isNameExists = this.entityData.some(entity => {
        return entity.entity_name?.toLowerCase() === enteredName?.toLowerCase();
      });
      return of(isNameExists ? { entityExists: true } : null).pipe(
        debounceTime(300),
        catchError(() => of(null))
      );
    };
  }

  isActivePage(pageIndex: number): number {
    return pageIndex;
  }




  subNavValueSetter(page: PAGE, type: string) {
    this.activePageId = page.pageId ? page.pageId : '';
    this.sharedService.setSidenavContentlistOption(type, true);
    this.sharedService.setWidgetListStatus(true);
  }

  navMenuSelectedStatusReset(){
    this.navMenuSelectedStatus = "";
  }

  pageDetailsSetter(page: PAGE) {
    this.navMenuSelectedStatusReset()
    this.webBuilderService.closeDrawer();
    if (page.pageId !== this.selectedPage.pageId) {
      const currentParams = { ...this.route.snapshot.queryParams };
      currentParams["pageId"] = page.pageId;
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: currentParams,
        queryParamsHandling: "merge",
      });
      this.webBuilderService.resetMainAndNavStatus();
      this.resetMenuNav = false;
      this.pagesdata.forEach((page) => {
        page.open = false;
      })
      page.open = true;
      this.pageStatus = false;
      this.selectedSections = this.selectedPage.forms;
    } else if (this.pageStatus) {
      this.pagesdata.forEach((page) => {
        if (page.pageId == this.selectedPage.pageId) {
          page.open = true;
        } else {
          page.open = false;
        }
      });
      this.pageStatus = false;
    } else {
      this.pagesdata.forEach((page) => {
        page.open = false;
      });
      this.pageStatus = true;
    }
    this.sharedService.setSidenavContentlistOption('', false);
  }

  getPageById(pageId: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_PAGE']);
    apiConfig.postData = { page_id: pageId }
    return this.httpService.placeAPICall(apiConfig);
  }

 async addPage(template:TemplateRef<any>,type:any,pageId?:any,pageName?:any) {
     this.isPageNameExist = false;
    this.entityForm.reset();
    this.entityData = await this.sharedService.fetchEntity(this.applicationId,'application')
    if(type=='edit'){
      this.editPageEntityData =  await this.sharedService.fetchEntity(pageId,'pageId');
      if (this.editPageEntityData?.length !== 0) {
        this.entityForm.patchValue({
          'selection': 'existing',
          'dropDownData': this.editPageEntityData[0]?.entity_id
        });
        this.entityFormEdit=true;
        this.entityFormEditWithValue=true;
      } else {
        this.entityForm.patchValue({
          'selection': 'new'
        });
        this.entityFormEdit=true;
      }}else{
      this.entityForm.patchValue(this.entityData.length !=0 ? {'selection':'existing'}:{'selection':'new'});
      this.entityFormEdit=true;
    }
    this.validPageName = false;
    setTimeout(() => {
      this.isPagenameEmpty = false;
    }, 10);
    this.sharedService.setSidenavContentlistOption('modifyPage',false);
    this.openModal(template,pageId,pageName,type);
   
  }
 
  async deletePage(pageId: any,templateref:any,pageName:string) {
    this.errorPage = pageName;
    const isDeleted = await this.sharedService.deletePage(pageId);
    if(isDeleted.success) {
      const currentParams = { ...this.route.snapshot.queryParams };
      currentParams['pageId'] = currentParams['pageId'] == pageId ? this.pagesdata[0]?.pageId : currentParams['pageId'];
      let index = this.pagesdata.findIndex((item:any) => item.pageId == pageId )
      if(index !=0 ){
      this.router.navigate(["home","web"], {
        queryParams: {
          "id":this.queryParamsData?.id,
          "applicationType":this.queryParamsData?.applicationType,
          "pageId":this.pagesdata[index-1]?.pageId
      }})}
      this.sharedService.setSidenavContentlistOption('',false);
    }else{
      this.pageDeleteMessage = isDeleted.message;
      this.openErrorModal(templateref)
    }
  }

  openErrorModal(template:TemplateRef<any>): void {
    const dialogRef = this.dialog.open(template, {
      disableClose: true
    });
  }

  



  rearrangeWidgets(event: CdkDragDrop<any>) {
    const formIndex = this.selectedPage.forms.findIndex((form:any) => form.formConfig.formType === pageTypeCnsts.SECTION)
    if(formIndex !== -1){
    moveItemInArray(this.selectedPage.forms[formIndex].widgets, event.previousIndex, event.currentIndex);
    const newIndexInDestination = event.currentIndex;

    if (this.selectedPage.pageType !== pageTypeCnsts.PREVIEW) {
      // this.sharedService.updateFormWidgetsRemapCode(this.selectedPage.forms[formIndex].widgets);
    } else {
      // this.sharedService.updateFormWidgetsRemapCode(this.selectedPage.forms[formIndex].widgets, this.selectedPage.forms[formIndex].formId);
    }
    }
  }

  rearrangeSection(event: CdkDragDrop<any>) {
    moveItemInArray(
      this.selectedSections,
      event.previousIndex,
      event.currentIndex
    );
    if (this.selectedPage.pageId) {
    }
  }


  sectionFormRenderer(page:PAGE,pageIndex:number,sectionIndex:number,form:any,tempFlag?:any)
  {
    this.selectedWidget.open = false;
    this.navMenuSelectedStatusReset();
    this.webBuilderService.closeDrawer();
    if(form.formId !== this.selectedForm.formId){
      if(form.formConfig.formType === pageTypeCnsts.MENU_PANEL){
        this.sharedService.setShowMenuStatus(true);
      }
      else{
        this.sharedService.setShowMenuStatus(false);
      }
      this.formIndex = sectionIndex;
      this.selectedForm.open = false;
      this.FormGroup.reset();
      this.selectedForm = form;
      form.open = true;
      this.sectionStatus = true;
      this.sectionValuePatcher(this.selectedForm);
      this.sectionState = false;
    }
    else if (this.formIndex === sectionIndex) {
      if (this.sectionState && tempFlag) {
        form.open = true;
        if(form.formConfig.formType === pageTypeCnsts.MENU_PANEL)
        {
          this.sharedService.setShowMenuStatus(true);
        }
        this.sectionStatus = true;
        this.sectionState = false;
      }
      else if (!tempFlag) {

        form.open = true;
        this.sectionState = true;
      }
      else {
        this.sectionStatus = false;
        form.open = false;
        this.sectionState = true;
        if(form.formConfig.formType === pageTypeCnsts.MENU_PANEL)
        {
          this.sharedService.setShowMenuStatus(false);
        }
      }
     
    }

    if (tempFlag) {
      this.sharedService.setSidenavContentlistOption('', false);
    }

  }

  sectionValuePatcher(section: FORM) {
    let bgColor = (section.formConfig?.style as any)?.['backgroundColor'];
    this.FormGroup.patchValue({
      key: section?.formKey,
      label: section?.formLabel,
      bgColor: bgColor
    })
  }

  widgetFormRenderer(
    page: PAGE,
    formIndex: number,
    widgetIndex: number,
    widget: WIDGET
  ) {
    this.navMenuSelectedStatusReset();
    this.webBuilderService.closeDrawer();
    if(widget.widgetId !== this.selectedWidget.widgetId){
      this.selectedWidget.open = false;
     
    this.sharedService.onMobileScreenDropUpdateData({
      data: widget.widgetId,
      onClick: true,
      sectionIndex: formIndex,
      widgetIndex: widgetIndex,
      widgetMeta: widget,
      });
      this.selectedWidget = widget;
      widget.open = true;
      this.sectionStatus = false;
      this.widgetState = false;
    }
    else if (this.widgetState) {
      widget.open = true;
      this.widgetState = false;
      this.sectionStatus = false;

    }
    else {
      this.widgetState = true;
      this.sectionStatus = false;
    }
    this.sharedService.setSidenavContentlistOption('widget', true);
  }


  changeOn(event: MatSlideToggleChange, widgetIndex: number, formIndex: number) {
    if (this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetConfig.enabled) {
      this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetConfig.enabled = event.checked
    } else {
      this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetConfig['enabled'] = event.checked
    }
    let  widgetPostData = {
      'applicationId': this.applicationId,
      'widgetConfig': this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetConfig,
      'userId' :  JSON.parse(localStorage.getItem('userInfo') as any )?.['userId'],
      'widgetId':this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetId,
    }
    this.sharedService.updateWidget(widgetPostData,this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetId).subscribe((data) => {
    })
    this.sharedService.setSelectedPage(this.selectedPage);
  }

  checkWidgetEnabled(page: any, formIndex: number, widgetIndex: number, widget: any) {
    if (widget.widgetConfig?.enabled || widgetIndex <= 1) {
      this.widgetFormRenderer(page, formIndex, widgetIndex, widget);
    }
    else {
      this.sharedService.setSidenavContentlistOption('promtStatus', true);
    }
    widgetIndex > 0 ?  this.sharedService.setShowMenuStatus(false) : null
  }

  updateFormData(data: any) {
    this.selectedForm.formLabel = data.label;
    this.selectedForm.formKey = data.key;
    this.selectedForm.formConfig.customStyleApplied = true;
    const formConfig = { ...this.selectedForm.formConfig };

    let newformConfig = { ...this.selectedForm.formConfing };
    newformConfig.style = {
      backgroundColor: data.bgColor
    }
    this.selectedForm.formConfig = {...formConfig};
    if(this.selectedPage.forms[this.formIndex]?.formConfig){
      this.selectedPage.forms[this.formIndex].formConfig.style = {backgroundColor:data.bgColor};
      this.sharedService.setSelectedPage(this.selectedPage);
    }
  }

  updateForm() {
    let formPostData = {
      formId: this.selectedForm.formId,
      formLabel: this.selectedForm.formLabel,
      formKey: this.selectedForm.formKey,
      formConfig: this.selectedPage.forms[this.formIndex].formConfig,
      applicationId: this.applicationId
    }
    this.sharedService.updateForm(formPostData, this.selectedForm.formId).subscribe((data: any) => {
    })
  }

  changeSubscribe() {
    this.FormGroup.valueChanges.pipe(
      debounceTime(600),
      distinctUntilChanged(),
    )
    .subscribe((formValue) => {
      this.updateFormData(formValue);
    });
    this.entityForm.get('selection')?.valueChanges.subscribe((value) => {
      const nameControl = this.entityForm.get('name');
      const dropDownDataControl = this.entityForm.get('dropDownData');
      if (value == 'new') {
        if(!this.entityFormEditWithValue){
          this.entityForm.get('dropDownData')?.reset();
        }
          nameControl?.setValidators([Validators.required]);
          dropDownDataControl?.setValidators(null);
      }else {
        this.entityForm.get('name')?.reset();
        dropDownDataControl?.setValidators([Validators.required]);
        nameControl?.setValidators(null);
      }
      nameControl?.updateValueAndValidity();
      dropDownDataControl?.updateValueAndValidity();
    });
  }

  saveEditedPageName(pageID: any, pageName: any) {
    this.isEditablePageName = false;

    let pagePostData = {
      applicationId: this.applicationId,
      pageId: pageID,
      pageName: pageName
    }
    this.sharedSrv.updatePageData(pagePostData as any).subscribe(async (res) => {
      if((!this.entityFormEdit && this.editPageEntityData[0]?.entity_id != this.entityForm.getRawValue()?.dropDownData) || this.entityFormEditWithValue){
        this.editPageEntityData[0]['removal_page_ids_list'] = [pageID]
        this.sharedService.saveEntiy('edit',this.editPageEntityData[0]).subscribe(async(data:any) => {
        await this.saveEntity(pageID);
        })
      }else{
        await this.saveEntity(pageID);
      }
    this.closeTemplate();
    this.editPage = false;
      const currentParams = { ...this.route.snapshot.queryParams }
      this.sharedSrv.getAllPages(currentParams['id']).subscribe((data: any) => {

      })
    }, (error: any) => {
      if (error?.error?.result?.includes("already exists")) {
        this.pageAlreadyExits = true;
      }
    }
    )
  }

  cancelEditedPageName(event: any) {
    this.isEditablePageName = false;
    event.stopPropagation();
  }

  startEditingPageName(event: any, page: any) {
    event.stopPropagation();
    this.selectedPageID = page.pageId;
    this.isEditablePageName = true;
    this.newPageName = page.pageName;
  }
  
  onPageNameAdd(event:any){
    let addPageName: any = this.addPageForm.value.name.trimLeft();
    addPageName == '' ? this.validPageName = true : this.validPageName = false;
    this.pageAlreadyExits = false;
    this.addPageForm.get('name')?.setValue(addPageName);
    if(this.addPageForm.value.name.trim() !== ""){
      this.isPagenameEmpty = false;
    } else{
      this.isPagenameEmpty = true;
    }
    this.isPageNameExist = this.pagesdata.filter((obj:any) => obj?.pageName?.toLowerCase()?.trim() === event?.target?.value?.toLowerCase()?.trim()).length > 0;
  }

  onMouseClick(){
    if(this.addPageForm?.value?.name !== null && this.addPageForm?.value?.name?.trim() !== "" ){
      this.isPagenameEmpty = false;
    } else{
      this.isPagenameEmpty = true;
    }
  }
  
  async createNavBar(data: any) {
    let applicationTheme: any;
    try {
      applicationTheme = await new Promise((resolve, reject) => {
        this.sharedSrv.themesObj.subscribe((theme: any) => {
          resolve(theme);
        }, (error: any) => {
          this.activeSpinner=false;
          reject(error);
        });
      });
      const pageData = await new Promise((resolve, reject) => {
        this.getPageById(data?.pageId).subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            this.activeSpinner=false;
            reject(error);
          }
        );
      });
    } catch (error) {
      this.activeSpinner=false;
    }
  }
  
async savePage(){
  if(!(this.addPageForm.invalid || this.entityForm.invalid || (this.isPageNameExist && !this.editPage))){
    this.activeSpinner=true;
      const currentParams = { ...this.route.snapshot.queryParams };
      let checkpage = ["splashscreen", "login", "landing"].includes(this.addPageForm.value.name.trim().toLowerCase())
      if(!this.editPage ){
        if( this.addPageForm.value.name.trim() !== "" && !checkpage){        
        this.sharedService.addPageData(currentParams['id'],this.addPageForm.value.name.trim().toLowerCase()).subscribe(async(data:any) => {
          await this.saveEntity(data?.pageId);
          this.activeSpinner=false;
          this.closeTemplate();
          const currentParams = { ...this.route.snapshot.queryParams };
          currentParams["pageId"] = data?.pageId;
          this.router.navigate([], {  
            relativeTo: this.route,
            queryParams: currentParams,
            queryParamsHandling: "merge",
          });
        },(error:any) => {
          if(error?.error?.result?.includes("already exists")){
            this.pageAlreadyExits = true;
            this.activeSpinner=false;
          }
        })
      }
      else{
        checkpage ? this.pageAlreadyExits = true : this.validPageName = true;
      }
      }else{
       this.saveEditedPageName(this.pageId,this.addPageForm.getRawValue()?.name)
      }
      this.isPageCreated = true;
  }
  }
  closeTemplate(): void {
    this.addPageForm.reset();
    this.dialog.closeAll();
    this.activeSpinner=false
    this.entityFormEdit=false;
    this.entityFormEditWithValue=false;
  }
  openModal(template: TemplateRef<any>, pageId: any, pageName: any, type: any): void {
    const dialogRef = this.dialog.open(template, {
      disableClose: true,restoreFocus:false
    });
    if (type != 'add') {
      this.editPage = true;
      this.pageAlreadyExits = false;
      this.pageId = pageId
      this.addPageForm.patchValue({
        name:this.toTitleCase(pageName)
      })
    } else {
      this.editPage = false;
      this.pageAlreadyExits = false;
    }
  }

  onSideNavWidgetDeleteClick(formIndex: number,form:any, widgetId: any,widget:any){
    if(widget.open){
      this.sharedSrv.setSidenavContentlistOption('widget',false);
    }
      this.sharedSrv.deleteWidget(this.selectedPage, formIndex, widgetId);
      let widgetIndex:any = this.selectedPage.forms[formIndex].widgets?.findIndex((widgetItem:any) => widgetItem.widgetId === widget.widgetId);
      this.selectedPage.forms[formIndex].widgets?.splice(widgetIndex,1);
        this.sharedSrv.setSelectedPage(this.selectedPage);
      
      let checkPreviewPage = widget.widgetConfig['previewPageId'];
      isNullOrUndefined(checkPreviewPage) ? null : this.sharedService.getAllPages(this.applicationId);   
  }
  deleteSection(index: number, section: any, page:PAGE ): void {
    let pageId:any=page?.pageId
    this.sharedSrv.deleteForm(section.formId, page).subscribe((value) => {
      this.getPageById(pageId).subscribe((data) => {
        this.sharedSrv.setSelectedPage(data);
      })
    });
  }

  slideTiggleChange(event:MatSlideToggleChange,widgetIndex:number,formIndex:number){
    if(widgetIndex == 0){
      this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetConfig.enable = event.checked
      if(event.checked == true){
        this.selectedPage.forms[formIndex].widgets[1].widgetConfig.style['margin-top'] = '40px'
      }else{
        this.selectedPage.forms[formIndex].widgets[1].widgetConfig.style['margin-top'] = '160px'
      }
      let  widgetPostData = {
        'widgetsData':[{
        'widgetId':this.selectedPage.forms[formIndex].widgets[1]?.widgetId,
        'widgetConfig':this.selectedPage.forms[formIndex].widgets[1].widgetConfig
        },{
          'widgetId':this.selectedPage.forms[formIndex].widgets[0]?.widgetId,
          'widgetConfig':this.selectedPage.forms[formIndex].widgets[0].widgetConfig
          }
        ]
      }
      this.sharedService.updateWidget(widgetPostData,this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetId).subscribe((data) => {
      })
      return;
    }
    if(this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetConfig.enable){
    this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetConfig.enable = event.checked
    }else{
      this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetConfig['enable'] = event.checked
    }
    let  widgetPostData = {
      'applicationId': this.applicationId,
      'widgetConfig': this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetConfig,
      'userId' :  JSON.parse(localStorage.getItem('userInfo') as any )?.['userId'],
      'widgetId':this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetId,
    }
    this.sharedService.updateWidget(widgetPostData,this.selectedPage.forms[formIndex].widgets[widgetIndex].widgetId).subscribe((data) => {
    })
    this.sharedService.setSelectedPage(this.selectedPage);
  }
 async saveEntity(newPageId:any){
  let entityFormValues:any = this.entityForm.getRawValue();
  if(entityFormValues?.selection != 'new'){
    let index = this.entityData.findIndex(item => item.entity_id === entityFormValues?.dropDownData);
    this.entityForm.patchValue({'dropDownData':this.entityData[index]})
    this.entityForm.getRawValue()?.dropDownData?.page_ids_list.push(newPageId);
  }
  entityFormValues = this.entityForm.getRawValue();
  this.sharedService.saveEntiy('add',{},this.applicationId,entityFormValues?.selection =='new' ? entityFormValues?.name : entityFormValues?.dropDownData ,newPageId).subscribe(async (data:any) => {
  })
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
  }

  toTitleCase(str: string): string {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

}

